import React from 'react'
import { TEXT_KEYS } from '../../../constants/textKeys'
import { useIsMobile } from '../../../hooks/useIsMobile'
import { useNavigation } from '../../../hooks/useNavigate'
import IMAGES_PATH from '../../../Images'
import { t } from '../../../translation/translation'
import { Button } from '../../common/Button'
import IconContainer from '../../common/IconContainer'
import { Touchable } from '../../common/Touchable'
import './style.css'

export const Footer = () => {

    const isMobile = useIsMobile()

    const {
        goToPrivacyPolicy,
        goToAppPermission,
        goToConfidentiality,
        goToHome,
        goToTermOfUse,
        goToAboutUs,
    } = useNavigation()

    return (
        <div className={isMobile ? 'footer-container-mobile' : 'footer-container'}>
            <div className='footer-child-container footer-company'>
                <Touchable onClick={goToHome}>
                <div className='footer-company-logo'>
                    <IconContainer
                        image_path={IMAGES_PATH.LOGO}
                    />
                    <h5>{t(TEXT_KEYS.SO_APP)}</h5>
                </div>
                </Touchable>
                <p className='footer-copyright-text'>© {new Date().getFullYear()} SoApp. All rights reserved.</p>
            </div>
            <div className='footer-child-container footer-store'>
                <div>
                    <Button
                        label={t(TEXT_KEYS.APPLE_STORE)}
                        iconLeft={IMAGES_PATH.LOGO_APPLE}
                    />
                </div>
                <div>
                    <Button
                        label={t(TEXT_KEYS.PLAY_STORE)}
                        iconLeft={IMAGES_PATH.LOGO_ANDROID}
                    />
                </div>
            </div>
            <div className='footer-child-containerfooter-category'>
                <div className=''>
                    <Touchable onClick={goToAboutUs}>
                        <h5 className='footer-link'>{t(TEXT_KEYS.ABOUT_US)}</h5>
                    </Touchable>
                    <Touchable onClick={goToPrivacyPolicy}>
                        <h5 className='footer-link'>{t(TEXT_KEYS.PRIVACY_POLICY_TITLE)}</h5>
                    </Touchable>
                    <Touchable onClick={goToAppPermission}>
                        <h5 className='footer-link'>{t(TEXT_KEYS.APP_PERMISSIONS_TITLE)}</h5>
                    </Touchable>
                    <Touchable onClick={goToConfidentiality}>
                        <h5 className='footer-link'>{t(TEXT_KEYS.CONFIDENTIALITY_AGREEMENT_TITLE)}</h5>
                    </Touchable>
                    <Touchable onClick={goToTermOfUse}>
                        <h5 className='footer-link'>{t(TEXT_KEYS.TERM_OF_USE_TITLE)}</h5>
                    </Touchable>
                </div>
            </div>
        </div>
    )
}

export default Footer